import { MutableRefObject, useState } from "react";
import { useLoggingContext } from "@/providers/logging-provider/logging-provider";

export const useAudioPlayerContext = () => {
  const [activePlayerRef, setActivePlayerRef] =
    useState<MutableRefObject<HTMLAudioElement>>();

  const logger = useLoggingContext();

  const isPlayerActive = (playerRef: MutableRefObject<HTMLAudioElement>) => {
    return playerRef === activePlayerRef;
  };

  const handlePlayButtonClick = async (
    playerRef: MutableRefObject<HTMLAudioElement>,
  ) => {
    const player = playerRef.current;

    if (playerRef === activePlayerRef) {
      player.pause();
      setActivePlayerRef(undefined);
    } else {
      if (activePlayerRef?.current) {
        activePlayerRef.current.pause();
      }

      try {
        await player.play();
        setActivePlayerRef(playerRef);
      } catch (err) {
        setActivePlayerRef(undefined);
        logger.logError(err as Error);
      }
    }
  };

  return { handlePlayButtonClick, isPlayerActive };
};
